export default {
  en: {
    labels: 'Labels',
    supplierLabels: 'Supplier labels',
    subEntityLabels: 'Sub-entity labels',
    descSuppliers:
      'Create and apply custom labels to your suppliers to improve filtering and reporting on different groups of suppliers.',
    descSubEntities:
      'Create and apply custom labels to your sub-entities to improve filtering and reporting on different groups of sub-entities.',
    customLabelsTitle: 'Labels',
    customLabelsPlaceholder: 'Select labels...',
    emptyDescription: 'No labels have been created',
    emptySubDescription: 'Use the add labels button above to create labels',
    noMatching: 'No matching labels',
    noMatchingDescription: 'Try a different search or filter',
    confirmTitle: "Are you sure you want to delete the label '{name}'?",
    confirmDescriptionSuppliers:
      'Deleting this label will remove it from all suppliers you have applied it to.',
    confirmDescriptionSubEntities:
      'Deleting the label will remove it from all applied sub-entities.',
    columns: {
      label: 'Label',
      description: 'Description',
      suppliers: 'Suppliers',
      subEntities: 'Sub-entities',
      actions: 'Actions',
    },
    filters: {
      entityName: 'labels',
      searchPlaceholder: 'Search labels',
    },
    modal: {
      addTitle: 'Add label',
      editTitle: 'Edit label',
    },
    buttons: {
      addLabel: 'Add label',
      edit: 'Edit',
      editLabels: 'Edit labels',
      cancel: 'Cancel',
      delete: 'Delete',
      save: 'Save',
      manageLabels: 'Manage labels',
      confirm: 'Confirm',
      retry: 'Retry',
    },
    message: {
      getError: 'Failed getting labels',
      saveError: 'The request failed',
      createSuccess: 'Label created',
      updateSuccess: 'Label updated',
      deleteSuccess: 'Label deleted',
    },
    error: {
      create: 'Failed to create label',
      nameTaken: 'A label with this name already exists',
      nameRequired: 'Enter a name for the label',
      update: 'Failed to update label',
      delete: 'Failed to delete label',
    },
    fields: {
      name: 'Name',
      description: 'Description',
      colour: 'Colour',
    },
    placeholder: {
      labelName: 'Label name',
      labelDescription: 'Label description',
    },
  },
};
